export default __webpack_public_path__ + "static/media/size_ex_618.1d78cd5c.png";